"use client";

import React, { useEffect, useRef } from "react";

interface AsyncThemeLinkProps {
  themeCssFilename: string;
}

export function AsyncThemeLink({ themeCssFilename }: AsyncThemeLinkProps) {
  const linkRef = useRef<HTMLLinkElement>(null);

  useEffect(() => {
    const link = linkRef.current;
    if (link) {
      setTimeout(() => {
        link.media = "all";
      }, 0);
    }
  }, []);
  return (
    <>
      <link
        ref={linkRef}
        rel="stylesheet"
        href={`/${themeCssFilename}`}
        media="print"
      />
      <noscript>
        <link
          rel="stylesheet"
          href={`/${themeCssFilename}`}
        />
      </noscript>
    </>
  );
}
